import { viewStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsView";

Object.assign(viewStyles, {
    mainLeftColumnGridItem: {
        width: 12,
        align: "top",
    },
    mainRightColumnGridItem: {
        width: 12,
        align: "top",
    },
});
